import type { JSX } from 'react';

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** aria-label for the switch — AI toggles carry their category name. */
  label: string;
  disabled?: boolean;
  busy?: boolean;
}

/**
 * Real switch (role="switch", aria-checked) — replaces the text-pill toggles
 * that read as plain buttons. Gold when on, muted when off; the thumb slides.
 */
export function Switch({ checked, onChange, label, disabled, busy }: SwitchProps): JSX.Element {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      className={`pear-switch${checked ? ' is-on' : ''}`}
      onClick={() => onChange(!checked)}
    >
      <span className="pear-switch-thumb" aria-hidden="true" />
      {busy ? <span className="pear-switch-busy" aria-hidden="true" /> : null}
    </button>
  );
}